<template>
  <div class="pl-3 pr-4 pb-3 kbWhite"
       style="position: fixed; z-index: 10; transform: translateX(-12px)"
       :style="{ width: barWidth, maxWidth: barWidth }">
    <div class="d-flex justify-space-between align-center flex-wrap">
      <span class="kbDarkBlueText--text text-capitalize"
              style="font-size: 24px">
          {{ title }}
      </span>
      <div>
        <slot/>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    barWidth () {
      if (this.$vuetify.breakpoint.smAndDown) {
        return 'calc(90vw - 24px)'
      }
      return this.minimizedSideMenu ? 'calc(90vw - 70px - 12px)' : 'calc(90vw - 270px - 12px)'
    }
  },
  props: {
    minimizedSideMenu: {
      type: Boolean,
      required: true
    },
    title: {
      type: String,
      default: ''
    }
  }
}
</script>
